
import { Component, Vue, Prop } from "vue-property-decorator";
@Component
export default class TheAlert extends Vue {
  @Prop(Object) value: any;
}
